import dadiConfig from './dadi'
import jiaheConfig from './jiahe'

//1=大地，2 = 嘉禾
export const channel_id = 1;

// 开发
const cfg = {
  appid: 'wx6a886129c4ee1464',
  // redirect_uri: 'https://cdev.oristarcloud.com',
}
// 租户id
console.log(process)
let tenant = Number(process.env.VUE_APP_tentant)
//let tenant = '400933'
// 测试环境
// if (process.env.VUE_APP_requestUrl.includes('newsit')) {
//   // cfg.redirect_uri = 'https://ctest.oristarcloud.com'
//   tenant = '400933'
// }
// // 预生产
// else if (process.env.VUE_APP_requestUrl.includes('capipre')) {
//   // cfg.redirect_uri = 'https://ctest.oristarcloud.com'
//   tenant = '421042'
// } else if (process.env.VUE_APP_requestUrl.includes('dadicinema')) {
//   // 生产环境
//   cfg.appid = channel_id === 1 ? 'wxfd37026460936cf2' : 'wx21f3b956b081f751'
//   // cfg.redirect_uri = channel_id === 1 ? 'https://h5.dadicinema.com' : 'https://osgh.dadicinema.com'
// }

export const edition = '1.0.2'

export const tenantId = tenant

export const weixinCfg = {
    appid: cfg.appid,
    redirect_uri: cfg.redirect_uri, 
    response_type: 'code',
    //snsapi_base （不弹出授权页面，直接跳转，只能获取用户openid），snsapi_userinfo （弹出授权页面，可通过openid拿到昵称、性别、所在地。并且， 即使在未关注的情况下，只要用户授权，也能获取其信息 ）
    scope: 'snsapi_userinfo',
    state: true,
  }

export const channel =  channel_id === 1 ? { no: 'MYSDADI', name: 'Malay land'} : { no: 'DDZY-JH', name: '大地自营-嘉禾'}

export default { ...(channel_id === 1 ? dadiConfig : jiaheConfig) }

console.log(111111111,channel_id,channel);

// 测试人员openId
export const testOpenId = {
  // 王雪洋
  'oh_0CwPNRgFol7k0yU0FVXY7Jwy4': 'opAtxt92sZFzHezny-85007ik_Ng',
  // 张志贺
  'oRUkdt0uZjLKyn9-E3j5PQqZ99RM': 'opAtxt7duxymILZXAb5cv5wm-NyY',
  // 王根
  'oRUkdt5_XzTn-4iRRh9H2XyJC40g': 'opAtxt96Hhzn_FOJXiru4M2FO8gI'
}



// WEBPACK FOOTER //
// ./src/components/config.js